module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 3-3b62da535cfa6cbe7f6799e03789ce98.jpg";